import axios from 'axios'
import { apiClient } from '@/api/client'
import { canPrint } from '@/features/orders/hooks/usePrintOrder'
import { deviceId } from '@/lib/deviceDiagnostics'
import { AppUpdater } from '@/plugins/app-updater'

interface EnrollResponse {
  valid: boolean
  restaurantId: number
  accessKey: string
}

/**
 * First start of a tablet set up by QR: redeems the single-use token from the provisioning extras
 * (plan 5.9). Returns the credentials to store, exactly like a manual restaurant login.
 */
export async function enrollWithProvisioningToken(): Promise<{ restaurantId: number; accessKey: string } | null> {
  if (!canPrint) return null
  const token = await AppUpdater.getEnrollmentToken()
    .then((result) => result.token)
    .catch(() => null)
  if (!token) return null
  try {
    const { data } = await apiClient.post<EnrollResponse>('/api/admin/device-enroll', { token, deviceId: deviceId() })
    await AppUpdater.clearEnrollmentToken()
    return data.valid ? { restaurantId: data.restaurantId, accessKey: data.accessKey } : null
  } catch (error) {
    // Used or expired: forget it and fall back to the normal login. Network errors keep it for the next start.
    if (axios.isAxiosError(error) && error.response?.status === 401) await AppUpdater.clearEnrollmentToken()
    return null
  }
}
